import React from "react";
import { View, TouchableOpacity } from "react-native";
import { STYLES } from "../assets/styles";

function RadioBtn({ size = 23, selected, onPress = () => {} }) {
  return (
    <TouchableOpacity onPress={onPress}>
      <View
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: "#00000020",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            width: size / 1.5,
            height: size / 1.5,
            borderRadius: size / 1.5 / 2,
            backgroundColor: selected ? STYLES.colors.darkBlue : "#00000020",
          }}
        ></View>
      </View>
    </TouchableOpacity>
  );
}

export default RadioBtn;
